"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAreaGroupAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextAreaGroup = require("../TextAreaGroup");

var _FormikAdapter = require("./FormikAdapter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TextAreaGroupAdapter = function TextAreaGroupAdapter(_ref) {
  var atts = _ref.atts,
      field = _ref.field,
      form = _ref.form,
      label = _ref.label,
      cashbotName = _ref.cashbotName,
      isPlastic = _ref.isPlastic,
      counterAriaLabel = _ref.counterAriaLabel,
      isRequiredField = _ref.isRequiredField,
      doFocus = _ref.doFocus;
  return _react.default.createElement(_FormikAdapter.FormikAdapter, {
    field: field,
    form: form,
    options: {
      atts: atts
    },
    render: function render(props) {
      return _react.default.createElement(_TextAreaGroup.TextAreaGroup, _extends({}, props, {
        label: label,
        cashbotName: cashbotName,
        isPlastic: isPlastic,
        counterAriaLabel: counterAriaLabel,
        isRequiredField: isRequiredField,
        doFocus: doFocus
      }));
    }
  });
};

exports.TextAreaGroupAdapter = TextAreaGroupAdapter;
TextAreaGroupAdapter.defaultProps = {
  isPlastic: false,
  isRequiredField: false,
  doFocus: false
};
TextAreaGroupAdapter.propTypes = {
  atts: _propTypes.default.shape({
    maxLength: _propTypes.default.number.isRequired
  }).isRequired,
  field: _propTypes.default.object.isRequired,
  form: _propTypes.default.object.isRequired,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  isPlastic: _propTypes.default.bool,
  counterAriaLabel: _propTypes.default.func.isRequired,
  isRequiredField: _propTypes.default.bool,
  doFocus: _propTypes.default.bool
};